module.exports = __webpack_public_path__ + "img/Kortlueke.0873c1bd.jpg";